import React, { useState } from 'react'

import {
  TableContainerStyled,
  TableStyled,
  TableFooter,
  TableCellStyled,
  TableRowStyled,
  TableBodyStyled,
  TableHeadStyled,
  Row
} from 'components'
import { DeleteIcon, ViewFileIcon } from 'components/Icons'
import {
  IEvidenceItems,
  DjurServices,
} from 'services/NGT/DjurServices'
import { SPACING } from 'utils'
import { useFile, useLoading, useModal } from 'hooks'
import { useDjurService } from '../../../../../../context'

interface ITableEvidences {
  isConsult: boolean
  tableData: IEvidenceItems[]
  handleDeleteFile: (_props: {
    idEvidenciaDjur?: number
    localId?: string
  }) => void
}

const TableEvidences: React.FC<ITableEvidences> = ({
  isConsult,
  tableData,
  handleDeleteFile,
}) => {
  const { showModal } = useModal()
  const { viewFile } = useFile()

  const [page, setPage] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled>Nome do arquivo</TableCellStyled>
              <TableCellStyled>Descrição / Observação</TableCellStyled>
              <TableCellStyled align="center">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(tableData?.length
              ? tableData?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : tableData)?.map((row, index) => (
                <TableRowStyled key={index + row.nomeArquivo}>
                  <TableCellStyled>{row.nomeArquivo}</TableCellStyled>
                  <TableCellStyled>{row.descricaoArquivo}</TableCellStyled>
                  <TableCellStyled align="center">
                    <Row justifyContent="center" alignItems="center">
                      <ViewFileIcon
                        onClick={() => viewFile({
                          local: {
                            base64: row.file,
                            filename: row.nomeArquivo
                          },
                          gedExternalID: row.cdGedExternalId,
                        })}
                      />
                      {!isConsult && (
                        <DeleteIcon
                          marginLeft={SPACING.spacing15}
                          cursor="pointer"
                          onClick={() =>
                            showModal({
                              handleConfirm: () => handleDeleteFile({
                                localId: row.localId,
                                idEvidenciaDjur: row.idEvidenciaDjur,
                              }),
                              message: `Tem certeza que deseja excluir o arquivo ${row.nomeArquivo}?`,
                              titleModal: 'Aviso',
                              txtButtonCancel: 'Cancelar',
                              txtButtonConfirm: 'Sim',
                              type: 'alert'
                            })
                          }
                        />
                      )}
                    </Row>
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}

export default TableEvidences
